export default class ReadspeakerButton extends HTMLAnchorElement {

    connectedCallback() {

        this.addEventListener("click", this.handleClick);
        
    }

    disconnectedCallback() {

        // Remove any event handlers and such here

    }

    handleClick = (e) => {

        e.preventDefault();
        readpage(this.href, 'readspeaker_button1');
        return false;

    }

    attributeChangedCallback(name, oldValue, newValue) {
        
    }

    //static get observedAttributes() { return ['foo']; }

}

customElements.define('readspeaker-button', ReadspeakerButton, { extends: 'a' });